import React, { useContext } from "react";
import styled from "styled-components";
import GlobalModalContext from "../../../contexts/GlobalModalContext";
import WBCRadioButton from "../../elements/WBCRadioButton";

const BodyContent = styled.div`
  text-align: left;
`;

const ModalText = styled.div`
  font-family: Helvetica;
  font-size: 14px;
  line-height: 1.71;
  color: ${props => props.theme["dark-grey"]};
  margin-bottom: 16px;
`;

const Bold = styled.span.attrs(() => ({}))`
  font-weight: bold;
`;
const PitcherModalBody = () => {
  const globalModalContext = useContext(GlobalModalContext);
  const { selectedPosition } = globalModalContext.state;
  const { lastName, firstName } = globalModalContext.state.content.player;

  const setPosition = position => {
    globalModalContext.dispatch({
      type: "setSelectedPosition",
      position: position
    });
  };

  return (
    <BodyContent>
      <ModalText>
        Only players with the position of LHR, LHS, RHR or RHS can be added as a pitcher.
        <br />
        Do you wish to update the position for{" "}
        <Bold>
          {firstName} {lastName}
        </Bold>{" "}
        to one of the following?
        <div className="mt-3 d-flex">
          <div className="mr-3">
            <WBCRadioButton checked={selectedPosition === "LHR"} onClick={() => setPosition("LHR")} label="LHR" />
          </div>
          <div className="mr-3">
            <WBCRadioButton checked={selectedPosition === "LHS"} onClick={() => setPosition("LHS")} label="LHS" />
          </div>
          <div className="mr-3">
            <WBCRadioButton checked={selectedPosition === "RHR"} onClick={() => setPosition("RHR")} label="RHR" />
          </div>
          <div className="mr-3">
            <WBCRadioButton checked={selectedPosition === "RHS"} onClick={() => setPosition("RHS")} label="RHS" />
          </div>
        </div>
      </ModalText>
    </BodyContent>
  );
};

PitcherModalBody.displayName = "BodyContent";

export default PitcherModalBody;
